import { render, staticRenderFns } from "./deanInputField.vue?vue&type=template&id=17088b6d&scoped=true"
import script from "./deanInputField.vue?vue&type=script&lang=ts"
export * from "./deanInputField.vue?vue&type=script&lang=ts"
import style0 from "./deanInputField.vue?vue&type=style&index=0&id=17088b6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17088b6d",
  null
  
)

export default component.exports